// Generated by npm run icons:generate. Do not edit.
// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
import { MaterialSymbol, type MaterialIconProps } from "./material-symbol";

const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M630-444H227.98q-15.29 0-25.64-10.29Q192-464.58 192-479.79t10.34-25.71q10.35-10.5 25.64-10.5H630L453.79-692.21Q443-703 443-717.5t11-25.98Q465-754 479.5-754t25.31 10.82L742.6-505.09q5.4 5.41 7.9 11.72 2.5 6.31 2.5 13.53 0 7.21-2.5 13.53Q748-460 743-455L505-217q-11 11-25 10.5t-25-11.02q-11-11.48-11-26.15 0-14.66 11-25.33l175-175Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M647-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h447L451-716q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l264 264q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L508-188q-11 11-27.5 11T452-188q-12-12-12-28.5t12-28.5l195-195Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M630-444H227.98q-15.29 0-25.64-10.29Q192-464.58 192-479.79t10.34-25.71q10.35-10.5 25.64-10.5H630L453.79-692.21Q443-703 443-717.5t11-25.98Q465-754 479.5-754t25.31 10.82L742.6-505.09q5.4 5.41 7.9 11.72 2.5 6.31 2.5 13.53 0 7.21-2.5 13.53Q748-460 743-455L505-217q-11 11-25 10.5t-25-11.02q-11-11.48-11-26.15 0-14.66 11-25.33l175-175Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M647-440H200q-17 0-28.5-11.5T160-480q0-17 11.5-28.5T200-520h447L451-716q-12-12-11.5-28t12.5-28q12-11 28-11.5t28 11.5l264 264q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L508-188q-11 11-27.5 11T452-188q-12-12-12-28.5t12-28.5l195-195Z"
    ]
  }
} as const;

export function ArrowForwardIcon(props: MaterialIconProps) {
  return <MaterialSymbol {...props} symbol="arrow_forward" artwork={artwork} />;
}
